import * as THREE from "three";

export class CORTOLoader extends THREE.Loader {
  constructor(options = {}, manager = THREE.DefaultLoadingManager) {
    super(manager);
    this.manager = manager;
    this.path = options.path || "";
    this.loadMaterial = options.loadMaterial || true;
  }

  load(url, onLoad, onProgress, onError) {
    const loader = new THREE.FileLoader(this.manager);
    loader.setPath(this.path);
    loader.setResponseType("arraybuffer");
    loader.load(
      url,
      (blob) => {
        const now = performance.now();
        const decoder = new CortoDecoder(blob);
        const model = decoder.decode();

        const ms = performance.now() - now;
        console.log(
          (model.nvert / 1024.0).toFixed(1) + "KV",
          ms.toFixed(1) + "ms",
          (model.nvert / 1000 / ms).toFixed(2) + "MV/s"
        );

        const geometry = this.geometry(model);
        onLoad(geometry);
      },
      onProgress,
      onError
    );
  }

  loadAsync(url) {
    return new Promise((resolve) => {
      this.load(url, (geometry) => {
        resolve(geometry);
      });
    });
  }

  geometry(model) {
    const geometry = new THREE.BufferGeometry();
    if (model.nface)
      geometry.setIndex(new THREE.BufferAttribute(model.index, 1));

    if (model.groups.length > 0) {
      let start = 0;
      for (let i = 0; i < model.groups.length; i++) {
        const g = model.groups[i];
        geometry.addGroup(start * 3, g.end * 3, i);
        start = g.end;
      }
    }

    geometry.setAttribute(
      "position",
      new THREE.BufferAttribute(model.position, 3)
    );
    // if (model.color)
    //   geometry.setAttribute(
    //     "color",
    //     new THREE.BufferAttribute(model.color, 3, true)
    //   );
    if (model.normal)
      geometry.setAttribute(
        "normal",
        new THREE.BufferAttribute(model.normal, 3, true)
      );
    // if (model.uv)
    //   geometry.setAttribute("uv", new THREE.BufferAttribute(model.uv, 2));
    return geometry;
  }

  materials(model, mesh) {
    const promise = { waiting: 0 };
    const options = {};

    options.color = 0xffffffff;

    if (model.nface) {
      options.side = THREE.DoubleSide;
      const materials = [];
      for (let i = 0; i < model.groups.length; i++) {
        const opt = Object.assign({}, options);
        const group = model.groups[i];
        if (group.properties.texture) {
          const textureLoader = new THREE.TextureLoader();
          promise.waiting++;
          opt.map = textureLoader.load(
            this.path + group.properties.texture,
            () => {
              mesh.dispatchEvent({ type: "change" });
            }
          );
        }

        materials.push(
          group.properties.texture && !model.normal
            ? new THREE.MeshBasicMaterial(opt)
            : new THREE.MeshLambertMaterial(opt)
        );
      }
      mesh.material = materials;
    } else {
      options.size = 2;
      options.sizeAttenuation = false;
      mesh.material = new THREE.PointsMaterial(options);
    }
  }
}
